<template>
  <div class="playlist">
    <button 
      class="rounded"
      v-for="(item, index) in playlistItems" :key="index" :style="{'--i': index}"
      :class="{current: content.id === item.id }"
      :title="item.name"
      @click="$emit('set',item.id)">
        <figure v-if="item.thumb" class="rounded">
          <img :src="item.thumb" />
        </figure>
        <div v-text="item.name"></div>
      </button>
  </div>
</template>

<script>
import { modalMixin } from '@/mixins/modalMixin.js'
export default {
  name: 'ModalPlaylist',
  mixins: [modalMixin]
}
</script>

<style lang="scss" scoped>
.playlist {
  position: relative;
  z-index: 600;
  margin-top: auto;
  margin-bottom: 0;
  height: 100px;
  // background: hotpink;
  max-width: 1024px;
  width: 100%;
  display: flex;
  // justify-content: flex-start;

  & > div {
    position: relative;
    width: 140px;
    display: flex;
    // animation: playlist-in 2s;
  }

  button {
    background: #fff;
    border: 3px solid transparent;
    width: 100%;
    margin-right: 15px;
    width: 140px;
    padding: 0;

    animation: playlist-in .3s ease-out ;
    animation-fill-mode: backwards;
    animation-delay: calc( 0.1s * var(--i) );
   
    //
    position: relative;
    // display: block;
    // flex: 1 1 0px;
    transition: transform 500ms;

    // display: flex;
    // flex-direction: column;

    figure {
      margin: 0;
      width: 100%;
      // flex: 4;
      height: 80px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    figure + div {
      flex: 1;
      margin: 0;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &.current ~ button {
      transform: translateX(19%);
    }
    &.current {
      // animation-name: playlist-current-in;
      border-color: #058fcc;

      //
      transform: scale(1.2) translateX(8%);
      z-index: 1;
    }
    
  }
}

@keyframes playlist-current-in {
  from {
    transform: translateY(100%) scale(1.2) translateX(8%);
  }
  to {
    transform: translateY(0) scale(1.2) translateX(8%);
  }
}
@keyframes playlist-in {
  from {
    transform: translateY(100%) translateX(19%);
  }
  to {
    transform: translateY(0) translateX(19%);
  }
}

</style>